import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import apiService from "../apiService";
import "../styles/_signup.scss";

const Signup = () => {
      const [firstName, setFirstName] = useState("");
      const [lastName, setLastName] = useState("");
      const [email, setEmail] = useState("");
      const [password, setPassword] = useState("");
      const [confirmPassword, setConfirmPassword] = useState("");
      const [address, setAddress] = useState("");
      const [companyName, setCompanyName] = useState("");
      const [error, setError] = useState("");
      const [successMessage, setSuccessMessage] = useState("");
      const navigate = useNavigate();

      const handleSubmit = async (e) => {
            e.preventDefault();
            setError("");
            setSuccessMessage("");

            if (password !== confirmPassword) {
                  setError("Passwords do not match");
                  return;
            }

            try {
                  apiService.signupUser(
                        {
                              first_name: firstName,
                              last_name: lastName,
                              email,
                              password,
                              address,
                              company_name: companyName,
                        },
                        (success, response) => {
                              if (success && response?.status === 201) {
                                    setSuccessMessage(response.data.message || "Signup successful! Please log in.");
                                    setTimeout(() => navigate("/"), 2000);
                              } else {
                                    setError(response?.data?.message || "Signup failed. Try again.");
                              }
                        }
                  );
            } catch (err) {
                  setError("Something went wrong. Please try again.");
            }
      };

      return (
            <div className="signup-container">
                  <img src="/images/logo-white.png" alt="Logo" className="logo" />
                  <div className="signup-box">
                        <form onSubmit={handleSubmit}>
                              <div className="form-group">
                                    <input
                                          type="text"
                                          value={firstName}
                                          placeholder="First Name"
                                          onChange={(e) => setFirstName(e.target.value)}
                                          required
                                    />
                              </div>
                              <div className="form-group">
                                    <input
                                          type="text"
                                          value={lastName}
                                          placeholder="Last Name"
                                          onChange={(e) => setLastName(e.target.value)}
                                          required
                                    />
                              </div>
                              <div className="form-group">
                                    <input
                                          type="email"
                                          value={email}
                                          placeholder="Email"
                                          onChange={(e) => setEmail(e.target.value)}
                                          required
                                    />
                              </div>
                              <div className="form-group">
                                    <input
                                          type="password"
                                          value={password}
                                          placeholder="Password"
                                          onChange={(e) => setPassword(e.target.value)}
                                          required
                                    />
                              </div>
                              <div className="form-group">
                                    <input
                                          type="password"
                                          value={confirmPassword}
                                          placeholder="Confirm Password"
                                          onChange={(e) => setConfirmPassword(e.target.value)}
                                          required
                                    />
                              </div>
                              <div className="form-group">
                                    <input
                                          type="text"
                                          value={address}
                                          placeholder="Address"
                                          onChange={(e) => setAddress(e.target.value)}
                                    />
                              </div>
                              <div className="form-group">
                                    <input
                                          type="text"
                                          value={companyName}
                                          placeholder="Company Name"
                                          onChange={(e) => setCompanyName(e.target.value)}
                                    />
                              </div>
                              {error && (
                                    <p className="error-message" style={{ color: "red" }}>
                                          {error}
                                    </p>
                              )}
                              {successMessage && (
                                    <p className="success-message" style={{ color: "green" }}>
                                          {successMessage}
                                    </p>
                              )}
                              <div className="signup-row">
                                    <span>
                                          <Link to="/" className="signup-link">
                                                Back
                                          </Link>
                                    </span>
                                    <button type="submit" className="signup-button">
                                          Sign up
                                    </button>
                              </div>
                        </form>
                  </div>
                  <div className="footer">
                        <div className="footer-links">
                              <a
                                    href="https://spraynozzle.com.au/contact/"
                                    className="footer-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                              >
                              Contact Us
                              </a>
                              <span className="vertical-bar">|</span>
                              <Link to="/privacy-policy" className="footer-link">
                                    Privacy Policy
                              </Link>
                              <span className="vertical-bar">|</span>
                              <Link to="/terms-conditions" className="footer-link">
                                    Terms & Conditions
                              </Link>
                        </div>
                        <div className="copyright">
                              ©2025 Spray Nozzle Engineering | All Rights Reserved
                        </div>
                  </div>
            </div>
      );
};

export default Signup;
